import dayjs from 'dayjs'
import { Duration, DurationUnitType } from 'dayjs/plugin/duration'

export const emptyDuration: Duration = dayjs.duration(0)

export function accumulateDuration(a: Duration, b: Duration): Duration {
    return a.add(b.asMilliseconds(), 'milliseconds')
}

export function subtractDuration(a: Duration, b: Duration, showNegativeDuration: boolean = false): Duration {
    const result = a.subtract(b.asMilliseconds(), 'milliseconds')
    return showNegativeDuration || result.asMilliseconds() > 0 ? result : emptyDuration
}

/**
 * Only supports input as number or string for performance reasons
 * If you want to use an object, such as { hours: 1 }, just use `duration(1, 'hours')`
 */
export const duration = (input: string | number, unit?: DurationUnitType): Duration => {
    if (typeof input === 'string') {
        return dayjs.duration(input)
    }

    return dayjs.duration(input, unit)
}
